import { render, staticRenderFns } from "./CheckBoxClass.vue?vue&type=template&id=53107ff0&scoped=true"
import script from "./CheckBoxClass.vue?vue&type=script&lang=js"
export * from "./CheckBoxClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53107ff0",
  null
  
)

export default component.exports